module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon9.5802067b.png";